import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  textColor: {
    color: theme.palette.text.subtitle,
  },
}));

export { useStyles };
